import ProgressBar from 'shared/components/ProfileProgressBar/ProgressBar';
import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { Fragment } from 'react/jsx-runtime';
import { EditProfileProgressText } from '../EditProfileSideInfo.styles';
import {
  EditProfileSideInfoLargeViewAvatarContainer,
  EditProfileSideInfoLargeViewAvatar,
  EditProfileSideInfoLargeViewDetailsContainer,
  EditProfilePrivateText,
} from './EditProfileSideInfoLargeView.styles';
import { IRepresentativesProfile } from 'shared/interfaces/IRepresentatives';
import { getRepresentativesDetails } from 'pages/Representatives/utils/getRepresentativesDetails';
import { Skeleton } from '@material-ui/lab';
import { useImageLoader } from 'pages/Representatives/features/AddRepresentatives/hooks/useImageLoader';
import { CameraIconTwoTone } from '@room-match/shared-ui-components';
import { CameraIconButton } from 'pages/Representatives/Representatives.styles';
import { getCompletionColor } from 'pages/Representatives/utils/getCompletionColor';

type EditProfileSideInfoLargeViewProps = {
  data: IRepresentativesProfile;
  handlePrimaryImageUpload?: VoidFunction;
};

const EditProfileSideInfoLargeView = ({ data, handlePrimaryImageUpload }: EditProfileSideInfoLargeViewProps) => {
  const { stage_name, represented_name, division_name, contact_number, country } = getRepresentativesDetails({
    talent: data.talent,
    agency: data.agency,
    division: data?.division,
    representation_type: data?.representation_type,
    casting_private: data?.casting_private,
    casting_company: data.casting_company,
  });

  const avatar =
    data?.primary_medium_attachment?.modified_attachment || data?.primary_medium_attachment?.attachment || '';

  const { src, loading } = useImageLoader(avatar);

  return (
    <Fragment>
      <EditProfileSideInfoLargeViewAvatarContainer>
        {loading ? <Skeleton style={{ width: '100%', height: '100%', borderRadius: 8 }} variant="rect" /> : null}
        <EditProfileSideInfoLargeViewAvatar src={src} style={{ display: loading ? 'none' : 'block' }} />
        {handlePrimaryImageUpload && !loading ? (
          <CameraIconButton
            className="cameraIconButton"
            style={{ position: 'absolute', opacity: 0, right: 10, bottom: 15 }}
            onClick={handlePrimaryImageUpload}
          >
            <CameraIconTwoTone />
          </CameraIconButton>
        ) : null}
      </EditProfileSideInfoLargeViewAvatarContainer>
      <EditProfileSideInfoLargeViewDetailsContainer>
        <div style={{ width: '100%', height: '100%', display: 'grid' }}>
          {data?.casting_private ? <EditProfilePrivateText>Private</EditProfilePrivateText> : null}
          <TypographyTooltip style={{ fontSize: 24, height: '100%', fontWeight: 600, marginBottom: 5 }}>
            {stage_name}
          </TypographyTooltip>
          <TypographyTooltip color="primary" style={{ fontSize: 16, fontWeight: 500, width: '100%' }}>
            {represented_name}
          </TypographyTooltip>
        </div>
        <div style={{ width: '100%' }}>
          {division_name ? <TypographyTooltip style={{ fontWeight: 600 }}>{division_name}</TypographyTooltip> : null}
          {contact_number ? <TypographyTooltip style={{ fontWeight: 600 }}>{contact_number}</TypographyTooltip> : null}
          {country ? <TypographyTooltip style={{ fontWeight: 600 }}>{country}</TypographyTooltip> : null}
        </div>
        <div style={{ width: '100%' }}>
          <EditProfileProgressText
            progress={data?.completeness || 0}
          >{`${data?.completeness || 0}% complete`}</EditProfileProgressText>
          <ProgressBar
            borderRadius={8}
            percent={data?.completeness || 0}
            completeColor={getCompletionColor(data?.completeness || 0)}
          />
        </div>
      </EditProfileSideInfoLargeViewDetailsContainer>
    </Fragment>
  );
};

export default EditProfileSideInfoLargeView;
